export const ABOUT_BASE_URL = '/about';